export const ATTSCHEDULE_LOADING = "ATTSCHEDULE_LOADING";
export const ATTSCHEDULE_RESET = "ATTSCHEDULE_RESET";
export const GET_ATTSCHEDULE = "GET_ATTSCHEDULE";
export const GET_ATTSCHEDULE_SUCCESS = "GET_ATTSCHEDULE_SUCCESS";
export const GET_ATTSCHEDULE_FAIL = "GET_ATTSCHEDULE_FAIL";
export const DELETE_ATTSCHEDULE = "DELETE_ATTSCHEDULE"
export const DELETE_ATTSCHEDULE_SUCCESS = "DELETE_ATTSCHEDULE_SUCCESS"
export const DELETE_ATTSCHEDULE_FAIL = "DELETE_ATTSCHEDULE_FAIL"
export const UPDATE_ATTSCHEDULE = "UPDATE_ATTSCHEDULE"
export const UPDATE_ATTSCHEDULE_SUCCESS = "UPDATE_ATTSCHEDULE_SUCCESS"
export const UPDATE_ATTSCHEDULE_FAIL = "UPDATE_ATTSCHEDULE_FAIL"
export const ADD_NEW_ATTSCHEDULE = "ADD_NEW_ATTSCHEDULE"
export const ADD_ATTSCHEDULE_SUCCESS = "ADD_ATTSCHEDULE_SUCCESS"
export const ADD_ATTSCHEDULE_FAIL = "ADD_ATTSCHEDULE_FAIL"